import React, { useContext } from 'react';

import {
  DesktopScreen,
  MobileTabletScreen,
  StaticContext
} from '@sm/webassets';
import { defineMessages, T } from '@sm/intl';
import { getClientEnvironmentDetails } from '@sm/utils';

import AppDirNavHeaderDesktop from './AppDirNavHeaderDesktop';
import AppDirNavHeaderMobile from './AppDirNavHeaderMobile';
import './app-dir-nav-header.scss';

const COPY = defineMessages({
  NAV_EXPLORE: {
    id: 'AppsDirectory.AppDirNavHeader.ExploreLink',
    defaultMessage: 'Explore',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user to initial page of the app directory site'
  },
  NAV_MANAGE: {
    id: 'AppsDirectory.AppDirNavHeader.ManageLink',
    defaultMessage: 'Manage',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user their installed apps and will be able to manage them'
  },
  NAV_DEVELOP: {
    id: 'AppsDirectory.AppDirNavHeader.DevelopLink',
    defaultMessage: 'Develop',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user to the developer portal'
  },
  NAV_PARTNER: {
    id: 'AppsDirectory.AppDirNavHeader.PartnerLink',
    defaultMessage: 'Partner',
    description:
      '[Type: Link][Vis.: High] - A link that will direct the user to the partner form page'
  }
});

const subdomainUri = (subdomain, domain) => {
  return `https://${subdomain}.${domain}.com`;
};

const navigationItems = domain => [
  { target: '/apps', text: <T desc={COPY.NAV_EXPLORE} /> },
  {
    target: '/apps/my-apps',
    text: <T desc={COPY.NAV_MANAGE} />,
    requiresAuthentication: true
  },
  {
    target: subdomainUri('developer', domain),
    text: <T desc={COPY.NAV_DEVELOP} />
  },
  {
    target: 'https://surveymonkey.wufoo.com/forms/partner-with-surveymonkey/',
    text: <T desc={COPY.NAV_PARTNER} />
  }
];

export function shouldDisplayNavItem(user, nav) {
  return (
    !nav.requiresAuthentication ||
    (nav.requiresAuthentication && user.isAuthenticated)
  );
}

const AppDirNavHeader = () => {
  const {
    user,
    environment: { domain }
  } = useContext(StaticContext);
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <DesktopScreen defaultMatches={isDesktop}>
        <div data-testid="AppDirNavHeader_Desktop">
          <AppDirNavHeaderDesktop
            navItems={navigationItems(domain)}
            shouldDisplayNavItem={item => shouldDisplayNavItem(user, item)}
            isAuthenticated={user.isAuthenticated}
            username={user && user.username ? user.username : ''}
          />
        </div>
      </DesktopScreen>
      <MobileTabletScreen defaultMatches={!isDesktop}>
        <div data-testid="AppDirNavHeader_Mobile">
          <AppDirNavHeaderMobile
            navItems={navigationItems(domain)}
            shouldDisplayNavItem={item => shouldDisplayNavItem(user, item)}
            isAuthenticated={user.isAuthenticated}
          />
        </div>
      </MobileTabletScreen>
    </>
  );
};

export default AppDirNavHeader;
